import { useState, useEffect } from 'react';
import axios from 'axios';
import { Button, Modal, Form, Dropdown, Input, Message } from 'semantic-ui-react';
import { Col, Row, SvgIcon } from '../common';
import { numBDeciRegex } from '../../common/constants';
import { BASE_URL } from '../../config/config';
const options = [
    { key: 'MW', value: 'mw', text: 'MW' },
    { key: 'MWh', value: 'mwh', text: 'MWh' },
    { key: 'GW', value: 'gw', text: 'GW' },
    { key: 'mt', value: 'mt', text: 'MT' },
    { key: 'Kgs', value: 'kgs', text: 'Kgs' },
    { key: 'Km', value: 'km', text: 'Km' },
    { key: 'Sqm', value: 'sqm', text: 'Sqm' },
    { key: 'Meter', value: 'meter', text: 'Meter' },
];

const EditCapacity = (props) => {
    let defaulterr = 'Unable to update capacity, please try again';
    let successMessage = 'Product Capacity Updated successfully.';

    const default_err_data = {
        current_capacity_error: '',
        future_capacity_error: '',
        current_unit_error: false,
        future_unit_error: false,
    };
    const default_form_data = {
        "current_capacity": '',
        "future_capacity": '',
        "current_unit": 'gw',
        "future_unit": 'gw',
        "company_id": '',
        "product_id": '',
        "product_name": '',
        "user_id": '',
    };
    const [form_data, setform_data] = useState(JSON.parse(JSON.stringify(default_form_data)));
    console.log('form_data ', form_data)





    const [open, setOpen] = useState(false)
    const [errors, set_errors] = useState(default_err_data);
    const [isFormValid, setisFormValid] = useState('');
    const [message, setMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [disableCapacitySubmit, setDisableCapacitySubmit] = useState(false);


    useEffect(() => {

        if (props.product) {
            let df = JSON.parse(JSON.stringify(default_form_data));
            df["current_capacity"] = props.product.current_capacity || ''
            df["future_capacity"] = props.product.future_capacity || ''
            df["current_unit"] = (props.product.current_unit) ? props.product.current_unit.toLowerCase() : 'gw'
            df["future_unit"] = (props.product.future_unit) ? props.product.future_unit.toLowerCase() : 'gw'
            df["company_id"] = props.company.id
            df["product_id"] = props.product.product_id
            df["product_name"] = props.product.product_name
            df["user_id"] = props.auth.id

            setform_data(df)
            console.log('df ', df)
        }


    }, [props.product])


    const handleValidation = (field, value) => {
        let error_field = field + '_error';
        setisFormValid(true);
        if (value !== '' && value !== undefined && value !== null && value !== false && value !== true) {
            if (numBDeciRegex.test(value)) {
                value = value.replace(/^\s+|\s+$/gm, '')
                errors[error_field] = false
            } else {
                value = '';
                errors[error_field] = true
            }
            set_errors(errors)
        }
    }

    const handleInputChange = (event) => {
        let current_value = event.target.value;
        if (current_value === '' || current_value === undefined || current_value === null) {
            current_value = '';
        }

        form_data[event.target.name] = current_value
        setform_data({ ...form_data });

        // validations 
        if (current_value !== '' && current_value !== undefined && current_value !== null) {
            handleValidation(event.target.name, current_value);
        }
    }

    const handleDropDown = (e, { name, value }) => {
        let current_value = value;
        form_data[name] = current_value
        setform_data({ ...form_data });
    }

    const handleClose = () => {
        setOpen(false);
    }

    const capacity_submit = () => {
        if (form_data.current_capacity != '' || form_data.future_capacity != '') {

            let isformvalid = '';
            setErrorMessage('')
            console.log('errors ', errors)
            for (var error in errors) {
                if (errors[error] === true) {
                    console.log('in here ')
                    isformvalid = false
                }
            }
            console.log('isformvalid', isformvalid)
            if (isformvalid === '' && isformvalid !== false) {
                isformvalid = true;
            }

            console.log('isformvalid ', isformvalid)
            setTimeout(() => {
                if (isformvalid) {
                    try {
                        let payload = form_data

                        axios.put(`${BASE_URL}/api/v1/product/capacity/update`, payload).then((response) => {

                            const { data, messages } = response.data;
                            if (data != undefined && messages.length > 0) {
                                if (messages[0]['type'] == 'success') {
                                    setMessage(successMessage)
                                    setTimeout(() => {
                                        handleClose()
                                        setform_data(JSON.parse(JSON.stringify(default_form_data)))
                                        set_errors(default_err_data)
                                        setErrorMessage('')
                                        props.refresh_products()
                                    }, 1500);

                                    setTimeout(() => {
                                        setMessage('')
                                    }, 3500);
                                } else {
                                    setErrorMessage(defaulterr)
                                }
                            } else {
                                setErrorMessage(defaulterr)
                            }
                        }).finally(() => {
                            //  setLoading(false)
                        })

                    } catch (error) {
                        console.log('in here ', error)
                        setErrorMessage(defaulterr)
                    }
                } else {
                    setErrorMessage('Incorrect form values, please check! ')
                }
            }, 300);
        }
    }
   

    return (
        <Modal
            className="editcapacity-modal"
            onClose={handleClose}
            onOpen={() => setOpen(true)}
            open={open}
            size='small'
            title="Edit Company"
            trigger={
                <SvgIcon className="mr-2" fill="#1A1642" name="edit" viewbox="0 0 31.5 31.5" />
            }
        >
            {open && (
                <>
                    <Modal.Header>
                        <h3>Edit Product</h3>
                        <div className='closeicon-header' onClick={handleClose}>
                            <SvgIcon name='close-alt' viewbox="0 0 15 15.001" />
                        </div>
                    </Modal.Header>
                    <Modal.Content>

                        <Modal.Description>
                            <Form>
                                <Form.Field>
                                    <label>Product Name</label>
                                    <input placeholder='Enter Product or Technology name' value={form_data.product_name} readOnly />
                                </Form.Field>
                                <Row>
                                    <Col xs="8">
                                        <Form.Field>
                                            <label>Current Capacity</label>
                                            <Input
                                                placeholder='Current Capacity'
                                                name="current_capacity"
                                                id="current_capacity"
                                                onChange={handleInputChange}
                                                defaultValue={form_data.current_capacity}
                                            />
                                        </Form.Field>
                                    </Col>
                                    <Col xs="4">
                                        <Form.Field>
                                            <label>&nbsp;</label>
                                            <Dropdown
                                                options={options}
                                                name="current_unit"
                                                id="current_unit"
                                                placeholder='Select'
                                                fluid
                                                selection
                                                defaultValue={form_data.current_unit}
                                                onChange={handleDropDown}
                                            />
                                        </Form.Field>
                                    </Col>

                                    {errors.current_capacity_error === true ? (<Col xs="12"><span className='text-danger'> Valid Current Capacity is required </span></Col>) : ''}

                                </Row>
                                <Row className='mt-3'>
                                    <Col xs="8">
                                        <Form.Field>
                                            <label>Future Capacity</label>
                                            <Input
                                                name="future_capacity"
                                                id="future_capacity"
                                                placeholder='Future Capacity'
                                                onChange={handleInputChange}
                                                defaultValue={form_data.future_capacity}
                                            />
                                        </Form.Field>
                                    </Col>
                                    <Col xs="4">
                                        <Form.Field>
                                            <label>&nbsp;</label>
                                            <Dropdown
                                                placeholder='Select'
                                                fluid
                                                selection
                                                options={options}
                                                name="future_unit"
                                                id="future_unit"
                                                defaultValue={form_data.future_unit}
                                                onChange={handleDropDown}
                                            />
                                        </Form.Field>
                                    </Col>
                                    {errors.future_capacity_error === true ? (<Col xs="12"><span className='text-danger'> Valid Future Capacity is required </span></Col>) : ''}
                                </Row>
                                <div className="text-right mt-5">
                                    <Button type='submit' onClick={handleClose}>Cancel</Button>
                                    <Button className="ml-1" type='submit' primary onClick={() => capacity_submit()} disabled={(form_data.current_capacity == '' && form_data.future_capacity == '')}>Save</Button>
                                </div>

                                {errorMessage != '' ? <span>
                                    <div className="text-left mt-2 mb-2">
                                        <Message className="reduce-msg-padding" compact visible error content={errorMessage} />
                                    </div>
                                </span> : <span></span>
                                }
                                {message != "" &&
                                    <span>
                                        <div className="text-left mt-2 mb-2">
                                            <Message className="reduce-msg-padding" compact visible success content={message} />
                                        </div>
                                    </span>
                                }
                            </Form>
                        </Modal.Description>
                    </Modal.Content>
                </>
            )}

        </Modal>
    )
}

export default EditCapacity;
